import styled from "styled-components";

import { Link as LinkDs } from "ds/Button";

export const Link = styled(LinkDs)`
  font-size: 15px;
`;
